import { useEffect } from 'react';
import { UserTaskFilter } from '../types';

const hasFilterBeenApplied = (defaultFilter, filterParams, filterKey) => {
  const _default = defaultFilter?.[filterKey];
  const params = filterParams?.[filterKey];
  if (!_default || !params || _default.length !== params.length) return false;
  const sorted1 = [..._default].sort();
  const sorted2 = [...params].sort();
  for (let i = 0; i < sorted1.length; i++) {
    if (sorted1[i] !== sorted2[i]) return false;
  }
  return true;
};

type Props = {
  filterParams: UserTaskFilter;
  triggerFilter: () => void;
  defaultFilter?: UserTaskFilter;
};

export const useHandleMultipleFilterChange = ({
  filterParams,
  triggerFilter,
  defaultFilter
}: Props) => {
  const {
    projectId: projectFilter,
    status: statusFilter,
    requesterId: requesterFilter,
    priorityId: priorityFilter,
    assignedUserId: assignedUserFilter
  } = filterParams || {};

  useEffect(() => {
    if (!hasFilterBeenApplied(defaultFilter, filterParams, 'projectId')) {
      triggerFilter();
    }
  }, [projectFilter]);

  useEffect(() => {
    if (!hasFilterBeenApplied(defaultFilter, filterParams, 'status')) {
      triggerFilter();
    }
  }, [statusFilter]);

  useEffect(() => {
    if (!hasFilterBeenApplied(defaultFilter, filterParams, 'priorityId')) {
      triggerFilter();
    }
  }, [priorityFilter]);

  useEffect(() => {
    if (!hasFilterBeenApplied(defaultFilter, filterParams, 'requesterId')) {
      triggerFilter();
    }
  }, [requesterFilter]);

  useEffect(() => {
    if (!hasFilterBeenApplied(defaultFilter, filterParams, 'assignedUserId')) {
      triggerFilter();
    }
  }, [assignedUserFilter]);
};
